const SharedWorker = require("./wss-socket.worker.js")

let worker
function newWorker () {
  worker = new SharedWorker("ws")
  worker.port.start()
  worker.port.onmessage = function (e) {
    const evt = e.data
    switch (evt.type) {
      case "connect-success":
        console.log("connect success")
        break
      case "connect-error":
        console.log("connect error")
        break
      case "log":
        console.log(evt)
        break
    }
  };
}

const SharedConnect = function (subscriber) {
  this.subscriber = subscriber
  newWorker()
  this.worker = worker
}

SharedConnect.prototype.connect = function (url, force = false) {
  this.url = url
  worker.port.postMessage({
    type: "connect",
    data: { url, force }
  })
}

SharedConnect.prototype.closeConn = function () {
  worker.port.postMessage({
    type: "closeConn"
  })
}

SharedConnect.prototype.destroy = function () {
  worker.port.postMessage({
    type: "destroy"
  })
}

SharedConnect.prototype.subscribe = function (data) {
  worker.port.postMessage({
    type: "subscribe",
    data: { ...data, subscriberName: this.subscriber }
  })
}

SharedConnect.prototype.cancelSub = function (data) {
  worker.port.postMessage({
    type: "cancelSubscribe",
    data: { ...data, subscriberName: this.subscriber }
  })
}

SharedConnect.prototype.produce = function (data) {
  worker.port.postMessage({
    type: "produce",
    data: { ...data, subscriber: this.subscriber }
  })
}

SharedConnect.prototype.testConnect = function () {
  worker.port.postMessage({
    type: "testConnect"
  })
}

export default SharedConnect
